export default __webpack_public_path__ + "static/media/pause_way.f75fce44.png";